/** biome-ignore-all lint/suspicious/noExplicitAny: allow any */

export const selectEnvelopeStickers = ({premiumDesign}: any) => premiumDesign.envelopeStickers;

export const selectEnvelope = ({premiumDesign}: any) => premiumDesign.envelope;

export const selectStamp = ({premiumDesign}: any) => premiumDesign.stamp;

export const selectLiner = ({premiumDesign}: any) => premiumDesign.liner;
